import { createApp } from 'vue'
import ElementPlus from 'element-plus'
import 'element-plus/dist/index.css'
import zhCn from 'element-plus/dist/locale/zh-cn.mjs'
import App from './App.vue'
import * as ElementPlusIconsVue from '@element-plus/icons-vue'
import router from './router'
const app = createApp(App)
app.use(router)
// 注册所有图标
for (const [key, component] of Object.entries(ElementPlusIconsVue)) {
    app.component(key, component)
}

// 抑制 ResizeObserver 警告
const debounce = (fn) => {
    let frame;
    return (...params) => {
        if (frame) {
            cancelAnimationFrame(frame);
        }
        frame = requestAnimationFrame(() => {
            fn(...params);
        });
    }
};

// 覆盖全局 ResizeObserver
const originalResizeObserver = window.ResizeObserver;
window.ResizeObserver = function (callback) {
    return new originalResizeObserver(debounce(callback));
};


app.use(ElementPlus, {
    locale: zhCn
})
app.mount('#app')